import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  markFormGroupDirty(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormControl) {
        control.markAsDirty();
      } else if (control instanceof FormGroup) {
        this.markFormGroupDirty(control);
      }
    });
  }

  checkPasswords(formGroup: FormGroup): void {
    const group = formGroup
    const passwordControl = group.get('password');
    const confirmPasswordControl = group.get('confirmPassword');
  
    if (passwordControl && confirmPasswordControl) {
      const pass = passwordControl.value;
      const confirmPass = confirmPasswordControl.value;
  
      if (pass !== confirmPass) {
        confirmPasswordControl.setErrors({ notSame: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    }
  }
}
